import { useState } from 'react';
import ClientCookies from 'js-cookie';
import { safeJsonParse } from 'src/utils/json';

export const FEATURE_FLAG = {
  cookieName: '_bh_ffs',
};

export default function useFeatureFlag<T>({
  flagName,
  defaultValue,
}: {
  flagName: string;
  defaultValue: T;
}) {
  const [value] = useState<T>(() => {
    if (typeof window !== 'undefined') {
      const featureFlagsFromCookie =
        safeJsonParse<Record<string, any>>(ClientCookies.get(FEATURE_FLAG.cookieName) || '{}') ||
        {};

      const flag = featureFlagsFromCookie[flagName];

      if (flag) {
        return flag;
      }
    }

    return defaultValue;
  });

  return value;
}
